"use client"

import { useEffect } from "react"

// Mediavine's CMP appends its CCPA/CPRA opt-out control to <body> as
// #consumer-privacy-footer-wrapper, after our app container — so by default it
// lands below the footer as a stray line on bare white. This slot moves that
// node into the footer's legal row.
//
// The node is MOVED, not cloned: the CMP binds its consent handler to the button
// element itself, and appendChild relocates a live node with its listeners
// intact. Cloning would produce a dead button that looks compliant and isn't.
//
// Fails safe by construction. If the effect never runs (hydration error, JS off,
// a route with no footer) the control simply stays where the vendor put it —
// visible and compliant, just uglier. Nothing here can hide it.

const WRAPPER_ID = "consumer-privacy-footer-wrapper"
const SLOT_ID = "ccpa-optout-slot"

export function CcpaOptOutSlot() {
  useEffect(() => {
    const slot = document.getElementById(SLOT_ID)
    if (!slot) return

    const adopt = () => {
      const wrapper = document.getElementById(WRAPPER_ID)
      if (!wrapper || wrapper.parentElement === slot) return
      slot.appendChild(wrapper)
    }

    // The CMP injects asynchronously and can re-inject when consent state
    // changes, so the observer stays live for the page's lifetime rather than
    // disconnecting after the first successful move. Scoped to direct children
    // of <body> (no subtree), which is the only place the CMP appends.
    adopt()
    const observer = new MutationObserver(adopt)
    observer.observe(document.body, { childList: true })
    return () => observer.disconnect()
  }, [])

  // Rendered with no children so React never reconciles what we move into it.
  return <div id={SLOT_ID} className="contents" />
}
